<app-nav-menu></app-nav-menu>
<body class="master-container">
  <mat-drawer-container class="mat-drawer-content-fgl" autosize>
    <mat-drawer #drawer
                class="example-sidenav"
                mode="side"
                opened="true"
                *ngIf="currentUserLogged != null">
      <div class="navbar-menu navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse nav-side-menu"
           id="navMenuOptions">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item"
              [routerLinkActive]="['link-active']"
              *ngIf="currentUserLogged.userPermission.home">
            <a class="nav-link nav-with-image nav-toggle"
               [ngClass]="{
                'nav-img-arrow-left': minimizedNavSideMenu == false,
                'nav-img-arrow-right': minimizedNavSideMenu == true
              }"
               (click)="toggle()">
            </a>
          </li>

          <li class="nav-item"
              [routerLinkActive]="['link-active']"
              *ngIf="currentUserLogged.userPermission.home.read">
            <a class="nav-link nav-with-image nav-img-home"
               [ngClass]="{
                'nav-with-image-min ':
                  minimizedNavSideMenu == true,
                'nav-fgl-selected': actualRouter == '/'
              }"
               [routerLink]="['/']">Inicio</a>
          </li>

          <li class="nav-item"
              [routerLinkActive]="['link-active']"
              *ngIf="currentUserLogged.userPermission.account.read">
            <a class="nav-link nav-with-image nav-img-account"
               [ngClass]="{ 'nav-with-image-min nav-img-account-min': minimizedNavSideMenu == true,
                            'nav-fgl-selected-left': actualRouter == '/pg-account' }"
               [routerLink]="['/pg-account']">Contas</a>
          </li>
          
          <li class="nav-item"
              [routerLinkActive]="['link-active']"
              *ngIf="currentUserLogged.userPermission.order.read">
            <a class="nav-link nav-with-image nav-img-tracking"
               [ngClass]="{ 'nav-with-image-min ': minimizedNavSideMenu == true,
                            'nav-fgl-selected-left': actualRouter == '/order-tracking' }"
               [routerLink]="['/order-tracking']">Pedidos</a>
          </li>

          <li class="nav-item"
              [routerLinkActive]="['link-active']"
              *ngIf="currentUserLogged.userPermission.orderBlocked.read">
            <a class="nav-link nav-with-image nav-img-order-blocked"
               [ngClass]="{
                'nav-with-image-min ': minimizedNavSideMenu == true,
                'nav-fgl-selected': actualRouter == '/order-blocked'
              }"
               [routerLink]="['/order-blocked']">Aprovação de pedidos</a>
          </li>

          <li class="nav-item"
              [routerLinkActive]="['link-active']"
              *ngIf="currentUserLogged.userPermission.payment.read">
            <a class="nav-link nav-with-image nav-img-payment"
               [ngClass]="{
                'nav-with-image-min ':
                  minimizedNavSideMenu == true,
                'nav-fgl-selected': actualRouter == '/credit-card-payment'
              }"
               [routerLink]="['/credit-card-payment']">Pagamentos</a>
          </li>

          <li class="nav-item"
              [routerLinkActive]="['link-active']"
              *ngIf="currentUserLogged.userPermission.orderService.read">
            <a class="nav-link nav-with-image nav-img-service"
               [ngClass]="{
                'nav-with-image-min ':
                  minimizedNavSideMenu == true,
                'nav-fgl-selected': actualRouter == '/order-service'
              }"
               [routerLink]="['/order-service']">Serviços</a>
          </li>

          <li class="nav-item"
              [routerLinkActive]="['link-active']"
              *ngIf="currentUserLogged.userPermission.managerHome.read">
            <a class="nav-link nav-with-image nav-img-management"
               [ngClass]="{
                'nav-with-image-min ':
                  minimizedNavSideMenu == true,
                'nav-fgl-selected': actualRouter == '/manager-home'
              }"
               [routerLink]="['/manager-home']">Home</a>
          </li>

          <li class="nav-item"
              [routerLinkActive]="['link-active']"
              *ngIf="currentUserLogged.userPermission.managerNotification.read">
            <a class="nav-link nav-with-image nav-img-notification"
               [ngClass]="{
                'nav-with-image-min ': minimizedNavSideMenu == true,
                'nav-fgl-selected': actualRouter == '/manager-notification'
              }"
               [routerLink]="['/manager-notification']">Push notification</a>
          </li>

          <li class="nav-item"
              [routerLinkActive]="['link-active']"
              *ngIf="currentUserLogged.userPermission.configurationSetting.read">
            <a class="nav-link nav-with-image nav-img-config"
               [ngClass]="{
                'nav-with-image-min ':
                  minimizedNavSideMenu == true,
                'nav-fgl-selected': actualRouter == '/config-setting'
              }"
               [routerLink]="['/config-setting']">Configurações gerais</a>
          </li>
        </ul>
      </div>
    </mat-drawer>

    <div class="div-mat-drawer-content">
      <div class="example-sidenav-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-drawer-container>
</body>
